import styled from 'styled-components/macro';
import { Col, Row } from '@zendeskgarden/react-grid';
import { variables } from 'theme/variables';

const {
  media_md: mediaMd,
  media_lg: mediaLg,
  custom_border_grey: customBorderGrey,
  custom_blue: customBlue,
  custom_slate: customSlate,
  color_grey_500: colorGrey500,
  color_grey_600: colorGrey600,
} = variables;

export const LeftColumn = styled(Col)`
  width: 100%;
  max-width: 100%;
  margin-right: 30px;
`;

export const RightColumn = styled(Col)`
  width: 100%;
  @media (min-width: 800px) {
    width: auto;
    max-width: 330px;
  }
`;

export const CtaHeader = styled('div')`
  display: none;
  @media ${mediaMd} {
    display: block;
  }
`;

export const TitleWrapper = styled('div')`
  display: ${(props) => (props.inline ? 'none' : 'block')};
  @media ${mediaLg} {
    display: ${(props) => (props.inline ? 'block' : 'none')};
  }
`;

export const AttributeWrapper = styled(Col)`
  margin-bottom: 30px;
  padding-right: 20px;
  &:last-child {
    * {
      border: none !important;
      padding-right: 0 !important;
    }
  }
`;

export const Attribute = styled('div')`
  padding-right: 30px;
  border-right: 1px solid ${customBorderGrey};
`;

export const AttributeRow = styled(Row)`
  margin-top: 10px;
  max-width: 1000px;
  @media ${mediaLg} {
    margin-top: ${(props) => (props.description ? '10px' : '30px')};
  }
`;

// V2 styles
export const HeroWrapper = styled('div')`
  height: 250px;
  max-width: 98%;
  margin-top: -20px;
  margin-bottom: 20px;
  border-radius: 1.5em;
  box-shadow: 0 4px 16px #c0cff7;
  background-image: url(/images/digitalBook.svg);
  background-repeat: no-repeat;
  background-position: 70% 50%;
  background-size: 30%;
  .product-hero-grid {
    display: flex;
    height: 100%;
  }
  .detailsColumn {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
  }
  .buttonColumn {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 920px) {
    .inquiryButton {
      width: 100px;
    }
  }
  @media (max-width: 767px) {
    background-image: none;
    .product-hero-grid {
      flex-wrap: wrap;
      wrap-direction: column;
    }
    .detailsColumn {
      margin-top: 10px;
    }
    .buttonColumn {
      flex-wrap: noWrap;
      flex-direction: inherit;
      justify-content: space-evenly;
      height: 80px;
      align-items: baseline;
      margin-bottom: 10px;
    }
  }
  @media (max-width: 468px) {
    height: 270px;
    .buttonColumn {
      height: 60px;
      margin-top: -20px;
    }
  }
`;

export const HeroTitle = styled('h1')`
  line-height: 32px;
  font-size: 26px;
  font-weight: 600;
  padding: 0 30px 20px;
  @media (max-width: 1024px) {
    line-height: 28px;
    font-size: 24px;
  }
  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 24px;
    padding: 0 10px 15px;
  }
`;

export const HeroDescription = styled('div')`
  font-size: 14px;
  color: ${customSlate};
  padding: 0 30px 30px;
  min-height: 75px;
  line-height: 22px !important;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    font-size: 12px;
    padding: 0 10px 15px;
  }
  @media (max-width: 425px) {
    padding-bottom: 0;
  }
`;

export const ActionButton = styled('div')`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  color: ${customBlue};
  margin-top: 20px;
  .actionButton {
    box-sizing: border-box;
    width: 17px;
    min-width: 17px;
    height: 50px;
    border-radius: 55%;
    margin-bottom: 10px;
  }
`;

// Technical Overview styling
export const TechnicalOverviewWrapper = styled('div')`
  margin-bottom: 30px;
  #technicalOverviewTitle {
    font-size: 18px;
    color: ${colorGrey600};
    font-weight: 500;
    width: 100%;
  }
  #technicalAttributes {
    display: flex;
  }
  @media (max-width: 1050px) {
    #technicalAttributes {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;

export const AttributeBox = styled(`div`)`
  height: 75px;
  min-width: 150px;
  margin: 10px 10px 20px;
  border-radius: 0.5em;
  box-shadow: 0 4px 16px #c0cff7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  font-weight: 600;
  .attributeValue {
    color: ${colorGrey500};
  }
  @media (max-width: 382px) {
    min-width: 130px;
  }
`;
